import { useContext } from 'react'
import styled from 'styled-components'

import { MODALS_ID } from '../../../constants'

import { ModalContext } from '../../../provider/ModalProvider'

import { Button } from '../../../components/button'
import { Modal } from '../../../components/modal'
import { Text } from '../../../components/text'

import { ReactComponent as AddressMapIcon } from '../../../assets/gui/address-map.svg'

export function AddressModal() {
  const { closeModal } = useContext(ModalContext)

  const close = () => closeModal(MODALS_ID.EMPTY_ADDRESS)

  return (
    <Modal id={MODALS_ID.EMPTY_ADDRESS}>
      <Content>
        <AddressMapIcon />
        <Text size={16} weight={500} lineHeight={24} block={true}>
          청약시, 필수 정보인 주소를 수집하고 있어요. 자택 주소를 입력해주세요.
        </Text>
      </Content>
      <Modal.Footer>
        <Button type="primary" href="/address" onClick={close}>
          확인
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  text-align: center;
`
